import { MobileInput } from "components/form-component/mobile-input/mobile-input";
import { SearchSelect } from "components/form-component/search-select/search-select";

import React from "react";
import { Spacer } from "styles/common/spacer";
import { useUpdateUserProfileForm } from "./hooks/use-update-user-profile-form";
import { LoginSuccessModal } from "./login-success-modal";
import { UserCitySource } from "./use-profile-form.types";
import {
  ButtonCTA,
  FormStyles,
  WrapperWidth,
  FormWrapper,
  UserProfileButtonGroups,
  SearchCityField,
  SearchCityFieldInput,
  SearchCityFieldLoader
} from "./user-profile-form.styles";
import { LocationPin } from "components/icons/location-pin";
import { HorizontalLoader } from "components/icons/horizontal-loader";

const UpdateUserProfileForm: React.FC = () => {
  const {
    control,
    cityList,
    fetchCityList,
    schoolList,
    fetchSchoolList,
    isValid,
    onSubmit,
    handleSubmit,
    isSuccessModalOpen,
    setIsSuccessModalOpen,
    getGPSData,
    geoLocationData,
    locationSource,
    setLocationSource,
    isLoading
  } = useUpdateUserProfileForm();

  const headerMessage = {
    primaryText: "Hore! Profilmu udah jadi.",
    secondaryText: "Waktunya mulai menggapai cita-citamu"
  };

  return (
    <FormWrapper onSubmit={handleSubmit(onSubmit)}>
      <FormStyles>
        <WrapperWidth width="50%">
          <SearchCityField
            {...(geoLocationData?.error || locationSource === null
              ? { onClick: () => getGPSData() }
              : {})}
            style={
              geoLocationData?.loading
                ? {
                    pointerEvents: "none",
                    cursor: "not-allowed"
                  }
                : {}
            }>
            {geoLocationData?.loading && (
              <SearchCityFieldLoader>
                <HorizontalLoader width="100%" height="100%" />
              </SearchCityFieldLoader>
            )}

            <SearchCityFieldInput
              isLoading={geoLocationData && geoLocationData?.loading}>
              <SearchSelect
                testId="city-dropdown"
                control={control}
                label="Kota Domisili"
                name="city"
                placeholder="Cth: Jakarta"
                options={cityList}
                onChange={fetchCityList}
                selectedOptionFromListCallback={() =>
                  setLocationSource(UserCitySource.DropDown)
                }
                iconToRender={<LocationPin width="100%" height="100%" />}
                textInputCallback={() => {
                  setLocationSource(UserCitySource.Manual);
                }}
              />
            </SearchCityFieldInput>
          </SearchCityField>
        </WrapperWidth>

        <WrapperWidth width="50%">
          <SearchSelect
            testId="school-dropdown"
            control={control}
            label="Nama Sekolah"
            name="school"
            placeholder="Cth: SMAN 1 Jakarta"
            options={schoolList}
            onChange={fetchSchoolList}
          />
        </WrapperWidth>
      </FormStyles>
      <Spacer token={[8, 0, 0]}></Spacer>
      <MobileInput
        label="Nomor HP Orangtua"
        placeholder="812345678900"
        control={control}
        name="parentNumber"
        hint="Nomornya untuk ngenalin CoLearn ke orangtua."
      />
      <UserProfileButtonGroups>
        <ButtonCTA
          data-testid="update-profile-button"
          type="submit"
          variant="primary"
          disabled={!isValid}
          isLoading={isLoading}>
          Simpan
        </ButtonCTA>
      </UserProfileButtonGroups>
      <LoginSuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
        headerMessage={headerMessage}
      />
    </FormWrapper>
  );
};

export { UpdateUserProfileForm };
